<template>
    <div class="flex-grid">
        <div class="flex-xl-6">
            <p>
                Assim como em todos os outros aspectos que dizem respeito à identidade visual da
                marca, trabalhamos com uma série de diretrizes fotográficas que caracterizam as
                produções da Chico Rei.
            </p>

            <p>
                Entendemos que nosso produto pede uma abordagem que tende mais para o básico,
                explorando detalhes e aspectos da fotografia que criem uma harmonia visual nas
                produções a serem desenvolvidas, sobretudo quando colocadas em contexto (peças,
                site, redes etc).
            </p>

            <h3>Diretrizes</h3>
            <h4>Styling</h4>
            <ul>
                <li>Casual, urbano;</li>
                <li>Explorar tendências em alta quando possível;</li>
                <li>Acessórios que auxiliem o direcionamento da atenção para a peça;</li>
                <li>“Menos é mais”.</li>
            </ul>
            <h4>Casting</h4>
            <ul>
                <li>Jovens adultos: 25 a 34 anos;</li>
                <li>Brasileiros (explorar a diversidade);</li>
                <li>Sem estereótipo de modelo profissional;</li>
                <li>Variedade de corpos e estilos;</li>
                <li>Todos os gêneros.</li>
            </ul>
            <h4>Tratamento e Pós-produção</h4>
            <ul>
                <li>Iluminação clara e abundante;</li>
                <li>Tratamento de pele suave</li>
            </ul>
            <h4>Atitude</h4>
            <ul>
                <li>Suave, casual;</li>
                <li>Passar sensação de movimento e conforto;</li>
                <li>Alegria, felicidade;</li>
                <li>Descontração;</li>
                <li>Conectada aos estilos em alta;</li>
                <li>Noção de comunidade: promover interação entre os modelos;</li>
            </ul>
            <h4>Enquadramento</h4>
            <ul>
                <li>Priorizar grandes áreas de respiro;</li>
                <li>
                    Analisar a finalidade de uso de cada fotografia, visto que cada uma tem um
                    formato e uma aplicação.
                </li>
            </ul>
        </div>
        <BrandBookGallery class="flex-xl-6" :images="images" />
    </div>
</template>

<script>
    import BrandBookGallery from '../../brand-book-6/sections/BrandBookGallery';

    export default {
        name: 'BrandBookFashion',

        components: { BrandBookGallery },

        data() {
            return {
                images: [
                    {
                        src: 'producao-de-moda/ARITANA 2.jpg',
                        alt: 'Produção de moda - exemplo 1',
                    },
                    {
                        src: 'producao-de-moda/BRASILIDADE 4.jpg',
                        alt: 'Produção de moda - exemplo 2',
                    },
                    {
                        src: 'producao-de-moda/C_EST LA VIE.jpg',
                        alt: 'Produção de moda - exemplo 3',
                    },
                    {
                        src: 'producao-de-moda/FALLGUYS5.jpg',
                        alt: 'Produção de moda - exemplo 4',
                    },
                    {
                        src: 'producao-de-moda/foto.png',
                        alt: 'Produção de moda - exemplo 5',
                    },
                    {
                        src: 'producao-de-moda/GO VEGAN 1.jpg',
                        alt: 'Produção de moda - exemplo 6',
                    },
                    {
                        src: 'producao-de-moda/instagram_0000_1.jpg',
                        alt: 'Produção de moda - exemplo 7',
                    },
                    {
                        src: 'producao-de-moda/PARANOID2.jpg',
                        alt: 'Produção de moda - exemplo 8',
                    },
                ],
            };
        },
    };
</script>
